enum ChallengePriority {
    LOW = "Low",
    NORMAL = "Normal",
    HIGH = "High",
}

export default ChallengePriority;